import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import PrivateRoute from './components/PrivateRoute';
import TagPage from './pages/TagPage';
import LandingPage from './pages/LandingPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Página principal - Landing Page */}
          <Route 
            path="/" 
            element={<LandingPage />} 
          />
          
          {/* Login para administradores */}
          <Route 
            path="/login" 
            element={<Login />}
          />
          
          {/* Panel de administración */}
          <Route 
            path="/admin" 
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            } 
          />
          
          {/* Ruta legacy para administrador (redirección) */}
          <Route 
            path="/administrador" 
            element={<Navigate to="/admin" replace />} 
          />
          
          {/* Página de etiqueta individual - SIN CAMBIOS */}
          <Route 
            path="/tag/:tagId" 
            element={<TagPage />} 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
